<template>
    <transition v-if="product && menuStore.vipProducts.length > 0" name="refresh" mode="out-in">
        <ProductThumbSmall :key="product.name" :product="product" :effect="false" @product-clicked="emit('product-clicked')"/>
    </transition>
</template>

<script setup>
// No changes - mantener async (componente thumb opcional usado condicionalmente)
const ProductThumbSmall = defineAsyncComponent(() => import("~/components/Product/Thumbs/ProductThumbSmall.vue"));

const props = defineProps({
    code: String
})

const menuStore = useMenuStore();

const product = computed(() => {
    let found = menuStore.vipProducts.find(p => p.keys?.includes(props.code));

    if (!found && props.code?.includes('-')) {
        const firstWord = props.code.split('-')[0];
        found = menuStore.vipProducts.find(p => p.keys?.includes(firstWord));
    }

    return found;
});

const emit = defineEmits(['product-clicked'])
</script>
